import script from "./device-info-item.vue?vue&type=script&lang=ts&setup=true"
export * from "./device-info-item.vue?vue&type=script&lang=ts&setup=true"

import "./device-info-item.vue?vue&type=style&index=0&id=322d66ea&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-322d66ea"]])

export default __exports__